import { generateCreateActionCreator, generateDeleteActionCreator, generateReadActionCreator, generateReadOneActionCreator, generateUpdateActionCreator } from 'actions/crudActionCreators';
import routes from 'actions/routes';
import ACTION_NAMES from 'actions/ACTION_NAMES';

const getRecordings = generateReadActionCreator(routes.API_PBX_CONFIG_RECORDINGS, ACTION_NAMES.PBX_CONFIG_RECORDINGS);
const updateRecordings = generateUpdateActionCreator(routes.API_PBX_CONFIG_RECORDINGS, ACTION_NAMES.PBX_CONFIG_RECORDINGS);

const getDestinationGroups = generateReadActionCreator(routes.API_PBX_CONFIG_DESTINATION_GROUPS, ACTION_NAMES.PBX_CONFIG_DESTINATION_GROUPS);
const getDestinationGroup = generateReadOneActionCreator(routes.API_PBX_CONFIG_DESTINATION_GROUP, ACTION_NAMES.PBX_CONFIG_DESTINATION_GROUP);
const addDestinationGroups = generateCreateActionCreator(routes.API_PBX_CONFIG_DESTINATION_GROUPS, ACTION_NAMES.PBX_CONFIG_DESTINATION_GROUPS);
const editDestinationGroup = generateUpdateActionCreator(routes.API_PBX_CONFIG_DESTINATION_GROUP, ACTION_NAMES.PBX_CONFIG_DESTINATION_GROUP);
const deleteDestinationGroup = generateDeleteActionCreator(routes.API_PBX_CONFIG_DESTINATION_GROUP, ACTION_NAMES.PBX_CONFIG_DESTINATION_GROUP);
const viewDestinations = generateReadActionCreator(routes.API_PBX_CONFIG_VIEW_DESTINATIONS, ACTION_NAMES.PBX_CONFIG_VIEW_DESTINATIONS);
const setPinned = generateReadActionCreator(routes.API_PBX_CONFIG_SET_PINNED, ACTION_NAMES.PBX_CONFIG_SET_PINNED);
const transferDestinations = generateReadActionCreator(routes.API_PBX_TRANSFER_DESTINTATIONS, ACTION_NAMES.PBX_CONFIG_TRANSFER_DESTINATIONS);


const getDylNumbers = generateReadActionCreator(routes.API_PBX_CONFIG_DYLNUMBERS, ACTION_NAMES.PBX_CONFIG_DYLNUMBERS);
const getDylNumber = generateReadOneActionCreator(routes.API_PBX_CONFIG_DYLNUMBERS, ACTION_NAMES.PBX_CONFIG_DYLNUMBERS);
const updateDylNumber = generateUpdateActionCreator(routes.API_PBX_CONFIG_DYLNUMBERS, ACTION_NAMES.PBX_CONFIG_DYLNUMBERS);
const getListOfExtensions = generateReadActionCreator(routes.API_PBX_CONFIG_LIST_EXTENSIONS, ACTION_NAMES.PBX_CONFIG_LIST_EXTENSIONS);
const getUsersWithExtensions = generateReadActionCreator(routes.API_PBX_CONFIG_WITH_EXTENSION, ACTION_NAMES.PBX_CONFIG_WITH_EXTENSIONS);

const getUsersWithExtensionsAndTeams = generateReadActionCreator(routes.API_PBX_CONFIG_WITH_EXTENSION_AND_TEAMS, ACTION_NAMES.PBX_CONFIG_LIST_EXTENSIONS_TEAMS);
const getPinnedExtensionsWithUsers = generateReadActionCreator(routes.API_PBX_CONFIG_LIST_PINNED_EXTENSIONS, ACTION_NAMES.PBX_CONFIG_LIST_PINNED_EXTENSIONS);
const getExtensionsByTeam = generateReadActionCreator(routes.API_PBX_CONFIG_EXTENSIONS_TEAM, ACTION_NAMES.PBX_CONFIG_EXTENSIONS_TEAM);

const getRoutingRules = generateReadActionCreator(routes.API_PBX_CONFIG_ROUTING_RULES, ACTION_NAMES.PBX_CONFIG_ROUTING_RULES);
const getRoutingRule = generateReadOneActionCreator(routes.API_PBX_CONFIG_ROUTING_RULE, ACTION_NAMES.PBX_CONFIG_ROUTING_RULES);
const updateRoutingRule = generateUpdateActionCreator(routes.API_PBX_CONFIG_ROUTING_RULE, ACTION_NAMES.PBX_CONFIG_ROUTING_RULES);
const deleteRoutingRule = generateDeleteActionCreator(routes.API_PBX_CONFIG_ROUTING_RULE, ACTION_NAMES.PBX_CONFIG_ROUTING_RULES);
const createRoutingRules = generateCreateActionCreator(routes.API_PBX_CONFIG_ROUTING_RULES, ACTION_NAMES.PBX_CONFIG_ROUTING_RULES);

const createCompanyVoicemails = generateCreateActionCreator(routes.API_PBX_CONFIG_VOICEMAIL_BOX, ACTION_NAMES.PBX_CONFIG_COMPANY_VOICEMAIL);
const getCompanyVoicemail = generateReadOneActionCreator(routes.API_PBX_CONFIG_VOICEMAIL_BOX, ACTION_NAMES.PBX_CONFIG_COMPANY_VOICEMAIL);
const updateCompanyVoicemail = generateUpdateActionCreator(routes.API_PBX_CONFIG_VOICEMAIL_BOX, ACTION_NAMES.PBX_CONFIG_COMPANY_VOICEMAIL);
const deleteCompanyVoicemail = generateDeleteActionCreator(routes.API_PBX_CONFIG_VOICEMAIL_BOX, ACTION_NAMES.PBX_CONFIG_COMPANY_VOICEMAIL);

const getConferenceRoom = generateReadOneActionCreator(routes.API_PBX_CONFIG_CONFERENCE_ROOM, ACTION_NAMES.PBX_CONFIG_CONFERENCE_ROOM); 
const updateConferenceRoom = generateUpdateActionCreator(routes.API_PBX_CONFIG_CONFERENCE_ROOM, ACTION_NAMES.PBX_CONFIG_CONFERENCE_ROOM);
const createConferenceRoom = generateCreateActionCreator(routes.API_PBX_CONFIG_CONFERENCE_ROOM, ACTION_NAMES.PBX_CONFIG_CONFERENCE_ROOM);
const deleteConferenceRoom = generateDeleteActionCreator(routes.API_PBX_CONFIG_CONFERENCE_ROOM, ACTION_NAMES.PBX_CONFIG_CONFERENCE_ROOM);

const createParkingLot = generateCreateActionCreator(routes.API_PBX_CONFIG_PARK, ACTION_NAMES.PBX_CONFIG_PARK);
const updateParkingLot = generateUpdateActionCreator(routes.API_PBX_CONFIG_PARK, ACTION_NAMES.PBX_CONFIG_PARK);
const getParkingLot = generateReadOneActionCreator(routes.API_PBX_CONFIG_PARK, ACTION_NAMES.PBX_CONFIG_PARK);
const deleteParkingLot = generateDeleteActionCreator(routes.API_PBX_CONFIG_PARK, ACTION_NAMES.PBX_CONFIG_PARK);

const getDestinations = generateReadActionCreator(routes.API_PBX_CONFIG_DESTINATIONS, ACTION_NAMES.PBX_CONFIG_DESTINATIONS);
const getPreferences = generateReadActionCreator(routes.API_PBX_CONFIG_PREFERENCES, ACTION_NAMES.PBX_CONFIG_PREFERENCES);
const updatePreferences = generateUpdateActionCreator(routes.API_PBX_CONFIG_PREFERENCES, ACTION_NAMES.PBX_CONFIG_PREFERENCES);
const readCompanyExtensions = generateReadActionCreator(routes.API_PBX_CONFIG_COMPANY_EXTENSION, ACTION_NAMES.PBX_CONFIG_COMPANY_EXTENSION);
const listPhones = generateReadActionCreator(routes.API_PBX_LIST_PHONES, ACTION_NAMES.PBX_LIST_PHONES);
const isDuplicatedName = generateReadActionCreator(routes.API_PBX_CONFIG_UNIQUE_NAME, ACTION_NAMES.PBX_CONFIG_UNIQUE_NAME);
const unusedExtensions = generateReadActionCreator(routes.API_PBX_CONFIG_UNUSED_EXTENSIONS, ACTION_NAMES.PBX_CONFIG_UNUSED_EXTENSIONS);

const getSounds = generateReadActionCreator(routes.API_PBX_CONFIG_SOUND, ACTION_NAMES.PBX_CONFIG_SOUNDS); 
const getSound = generateReadOneActionCreator(routes.API_PBX_CONFIG_SOUND, ACTION_NAMES.PBX_CONFIG_SOUND); 
const createSound = generateCreateActionCreator(routes.API_PBX_CONFIG_SOUND, ACTION_NAMES.PBX_CONFIG_SOUND);
const updateSound = generateUpdateActionCreator(routes.API_PBX_CONFIG_SOUND, ACTION_NAMES.PBX_CONFIG_SOUND);
const deleteSound = generateDeleteActionCreator(routes.API_PBX_CONFIG_SOUND, ACTION_NAMES.PBX_CONFIG_SOUND);
const getSoundOptions = generateReadActionCreator(routes.API_PBX_CONFIG_SOUND_OPTIONS, ACTION_NAMES.PBX_CONFIG_SOUND_OPTIONS); 

const getUserGroups = generateReadActionCreator(routes.API_PBX_CONFIG_USER_GROUPS, ACTION_NAMES.PBX_CONFIG_USER_GROUPS)
const updateUserGroups = generateUpdateActionCreator(routes.API_PBX_CONFIG_USER_GROUPS, ACTION_NAMES.PBX_CONFIG_USER_GROUPS, () => {}, () => {}, '', true)

const getUserExtensions = generateReadActionCreator(routes.API_PBX_CONFIG_USER_EXTENSION, ACTION_NAMES.PBX_CONFIG_USER_EXTENSION)
const getExtension = generateReadOneActionCreator(routes.API_PBX_CONFIG_EXTENSION, ACTION_NAMES.PBX_CONFIG_EXTENSION);
const updatePbx = generateUpdateActionCreator(routes.API_PBX_CONFIG_DOMAINS, ACTION_NAMES.PBX_CONFIG_DOMAINS)
const updateExtension = generateUpdateActionCreator(routes.API_PBX_CONFIG_USER_EXTENSION, ACTION_NAMES.PBX_CONFIG_USER_EXTENSION)
const getUsers = generateReadActionCreator(routes.API_PBX_CONFIG_USERS, ACTION_NAMES.PBX_CONFIG_USERS)

const readCallerIdOptions = generateReadActionCreator(routes.API_PBX_CONFIG_CID_OPTIONS, ACTION_NAMES.CID_OPTIONS, 'cid');
const readCallerIdPrefs = generateReadActionCreator(routes.API_PBX_CONFIG_CID_PREFS, ACTION_NAMES.CID_PREFS, 'cid_prefs');
const updateCallerIdPrefs = generateUpdateActionCreator(routes.API_PBX_CONFIG_UPDATE_CID_PREFS, ACTION_NAMES.UPDATE_CID_PREFS, () => {}, () => {}, undefined, false);
const removeSound = () => {
    return {
        type: 'REMOVE_SOUND',
    }
}

const readIvrs = generateReadActionCreator(routes.API_PBX_CONFIG_IVR, ACTION_NAMES.PBX_CONFIG_IVR);
const getIvr = generateReadOneActionCreator(routes.API_PBX_CONFIG_IVR, ACTION_NAMES.PBX_CONFIG_IVR);
const createIvr = generateCreateActionCreator(routes.API_PBX_CONFIG_IVR, ACTION_NAMES.PBX_CONFIG_IVR);
const updateIvr = generateUpdateActionCreator(routes.API_PBX_CONFIG_IVR, ACTION_NAMES.PBX_CONFIG_IVR);
const deleteIvr = generateDeleteActionCreator(routes.API_PBX_CONFIG_IVR, ACTION_NAMES.PBX_CONFIG_IVR);

const getExternalNumbers = generateReadActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER);
const getExternalNumber = generateReadOneActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER);
const createExternalNumber = generateCreateActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER);
const updateExternalNumber = generateUpdateActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER);
const deleteExternalNumber = generateDeleteActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER);
const uniqueExternalNumber = generateReadOneActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER_UNIQUE, "unique");
const getExternalUsers = generateReadActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER_USERS, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER_USERS);
const getExternalVerificationCode = generateReadActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER_VERIFICATION_CODE, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER_VERIFICATION_CODE);
const getPhoneTab = generateReadActionCreator(routes.API_PBX_CONFIG_PHONE_TAB, ACTION_NAMES.PBX_CONFIG_PHONE_TAB);
const verifyExternalNumberForm = generateUpdateActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER_VERIFICATION_CODE, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER_VERIFICATION_CODE);
const getVerifiedExternals = generateReadActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER_VERIFIED, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER_VERIFIED);
const getExternalNumberProductLimits = generateReadActionCreator(routes.API_PBX_CONFIG_EXTERNAL_NUMBER_PRODUCT_LIMITS, ACTION_NAMES.PBX_CONFIG_EXTERNAL_NUMBER_PRODUCT_LIMITS);
const removeExternalNumber = () => {
    return {
        type: 'REMOVE_EXTERNAL_NUMBER',
    }
}
const phoneStatus = (type, hardphone, externalSoftphone, leadConnect) => {
    return {
        type,
        hardphone,
        externalSoftphone,
        leadConnect
    }
}

const createHolidaySchedule = generateCreateActionCreator(routes.API_PBX_CONFIG_HOLIDAY_SCHEDULE, ACTION_NAMES.PBX_CONFIG_HOLIDAY_SCHEDULE);
const getHolidaySchedule = generateReadOneActionCreator(routes.API_PBX_CONFIG_HOLIDAY_SCHEDULE, ACTION_NAMES.PBX_CONFIG_HOLIDAY_SCHEDULE);
const getHolidaySchedules = generateReadActionCreator(routes.API_PBX_CONFIG_HOLIDAY_SCHEDULE, ACTION_NAMES.PBX_CONFIG_HOLIDAY_SCHEDULE);
const updateHolidaySchedule = generateUpdateActionCreator(routes.API_PBX_CONFIG_HOLIDAY_SCHEDULE, ACTION_NAMES.PBX_CONFIG_HOLIDAY_SCHEDULE);
const deleteHolidaySchedule = generateDeleteActionCreator(routes.API_PBX_CONFIG_HOLIDAY_SCHEDULE, ACTION_NAMES.PBX_CONFIG_HOLIDAY_SCHEDULE);

export default {
    getRecordings,
    updateRecordings,
    getPreferences,
    updatePreferences,
    getDylNumbers,
    getDylNumber,
    getDomains: generateReadActionCreator(routes.API_PBX_CONFIG_DOMAINS, ACTION_NAMES.PBX_CONFIG_DOMAINS),
    updatePbx,
    getDestinations,
    updateDylNumber,
    readCompanyExtensions,
    getDestinationGroups,
    addDestinationGroups,
    deleteDestinationGroup,
    getDestinationGroup,
    editDestinationGroup,
    listPhones,
    getListOfExtensions,
    getUnusedExtensions: generateReadActionCreator(routes.API_PBX_CONFIG_UNUSED_EXTENSION, ACTION_NAMES.PBX_CONFIG_UNUSED_EXTENSIONS),
    getRoutingRules,
    isDuplicatedName,
    createRoutingRules,
    getRoutingRule,
    updateRoutingRule,
    deleteRoutingRule,
    createCompanyVoicemails,
    getCompanyVoicemail,
    updateCompanyVoicemail,
    createConferenceRoom,
    createParkingLot,
    getConferenceRoom,
    getParkingLot,
    updateParkingLot,
    updateConferenceRoom,
    unusedExtensions,
    deleteCompanyVoicemail,
    deleteConferenceRoom,
    deleteParkingLot,
    getSounds,
    getSound,
    createSound,
    updateSound,
    deleteSound,
    getSoundOptions,
    getUserExtensions,
    getUserGroups,
    updateUserGroups,
    getExtension,
    getUsers,
    readCallerIdOptions,
    readCallerIdPrefs,
    updateCallerIdPrefs,
    updateExtension,
    removeSound,
    createIvr,
    getUsersWithExtensions,
    readIvrs,
    getIvr,
    updateIvr,
    deleteIvr,
    viewDestinations,
    setPinned,
    getUsersWithExtensionsAndTeams,
    getPinnedExtensionsWithUsers,
    getExtensionsByTeam,
    createExternalNumber,
    getExternalNumbers,
    getExternalNumber,
    removeExternalNumber,
    updateExternalNumber,
    deleteExternalNumber,
    uniqueExternalNumber,
    getExternalUsers,
    getExternalVerificationCode,
    verifyExternalNumberForm,
    transferDestinations,
    phoneStatus,
    createExtension: generateCreateActionCreator(routes.API_PBX_CONFIG_EXTENSION, ACTION_NAMES.PBX_CONFIG_EXTENSION),
    getUnusedUserExtensions: generateReadOneActionCreator(routes.API_PBX_CONFIG, ACTION_NAMES.PBX_CONFIG_UNUSED_USER_EXTENSIONS, 'unused_extensions'),
    getVerifiedExternals,
    getPhoneTab,
    setPause: generateUpdateActionCreator(`${routes.API_PBX_CONFIG}/domain`, ACTION_NAMES.PBX_CONFIG_PBX_PAUSE, () => {}, () => {}, 'pbx_pause'),
    resetPasswords: generateUpdateActionCreator(`${routes.API_PBX_CONFIG}/domain`, ACTION_NAMES.PBX_CONFIG_PBX_RESET_PASSWORDS, () => {}, () => {}, 'pbx_reset_passwords'),
    getExtensionInfo: generateReadOneActionCreator(`${routes.API_PBX_CONFIG}/domain`, ACTION_NAMES.GET_EXTENSION_INFO, 'extensions_info'),
    getAccountPbx: generateReadOneActionCreator(routes.API_PBX_CONFIG, ACTION_NAMES.PBX_CONFIG_ACCOUNT_PBX, 'pbx'),
    getAccountPbxServers: generateReadOneActionCreator(routes.API_PBX_CONFIG, ACTION_NAMES.PBX_CONFIG_ACCOUNT_PBX_SERVERS, 'pbx_servers'),
    getExternalNumberProductLimits,
    createHolidaySchedule,
    getHolidaySchedule,
    getHolidaySchedules,
    updateHolidaySchedule,
    deleteHolidaySchedule,
}
